const webcast_es = require('./webcast.json')
export default webcast_es